// Azure AD authentication configuration
// Updated to use runtime configuration from /.config.json

import { getConfig } from './services/config';

/**
 * Get MSAL configuration asynchronously
 * This must be called and awaited before initializing PublicClientApplication
 */
export async function getMsalConfig() {
  const config = await getConfig();
  
  return {
    auth: {
      clientId: config.azureClientId || '',
      authority: `https://login.microsoftonline.com/${config.azureTenantId || 'common'}`,
      redirectUri: config.azureRedirectUri || window.location.origin,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    }
  };
}

// Add scopes for MS Graph API
export const loginRequest = {
  scopes: ['User.Read']
};
